export default class ToggleBtn {
    constructor({
                    triggerElement,
                    toggleElement,
                    showText,
                    hideText,
                    textChangedElement = triggerElement,
                    isShowed = true
    }) {
        if (!triggerElement || !toggleElement) throw new Error('Укажате сво-ва triggerElement и toggleElement');

        this.$triggerElement = triggerElement;
        this.$toggleElement = toggleElement;
        this.$textChangedElement = textChangedElement;
        this.showText = showText;
        this.hideText = hideText;
        this._isShowed = isShowed;
    }

    hide() {
        this.hideText && this.$textChangedElement.text(this.hideText);
        this.$toggleElement.hide(0);
        this.$triggerElement.removeClass('is-open');
        this._isShowed = false;
    }

    show() {
        this.showText && this.$textChangedElement.text(this.showText);
        this.$toggleElement.show(0);
        this.$triggerElement.addClass('is-open');
        this._isShowed = true;
    }

    _triggerElementClickHandler = e => {
        e && e.preventDefault && e.preventDefault();
        if (e.target && this.$toggleElement.has($(e.target)).length) return;

        this._isShowed ? this.hide() : this.show();
    };

    get isShowed() {
        return this._isShowed;
    }

    init() {
        this.$triggerElement.on('click', this._triggerElementClickHandler);
        this._isShowed ? this.show() : this.hide();
    }
}



// WEBPACK FOOTER //
// ./components/toggleBtn.js